/*
  Two-column mobile menu (sections/uoy-mb-menu.liquid).
  The theme puts the menu into #t4s-menu-drawer after the page has loaded (or from its
  sessionStorage cache), so everything here is delegated / looked up when needed.
   - tapping a category on the left shows its panel (no page load); arrow keys move between them
   - images only get their src when the drawer is open and their category is shown
   - the last category viewed is reopened next time (this browser tab only)
   - theme editor: selecting the section or one of its blocks opens the drawer on it
*/
(() => {
  if (window.__uoyMbMenu) return;
  window.__uoyMbMenu = true;

  const DRAWER = '#t4s-menu-drawer';
  const STORE_KEY = 'uoyMbmTab';
  const root = () => document.querySelector('[data-uoy-mbm]');
  const drawerOpen = () => {
    const drawer = document.querySelector(DRAWER);
    return !!drawer && drawer.getAttribute('aria-hidden') === 'false';
  };

  const loadImages = (scope) => {
    if (!scope) return;
    scope.querySelectorAll('img[data-uoy-src]').forEach((img) => {
      img.addEventListener('load', () => img.classList.add('is-loaded'), { once: true });
      img.addEventListener('error', () => img.classList.add('is-loaded'), { once: true });
      if (img.dataset.uoySrcset) img.srcset = img.dataset.uoySrcset;
      img.src = img.dataset.uoySrc;
      img.removeAttribute('data-uoy-src');
      img.removeAttribute('data-uoy-srcset');
    });
  };

  const showVisible = (menu) => {
    loadImages(menu.querySelector('.uoy-mbm__banner'));
    loadImages(menu.querySelector('[data-uoy-panel]:not([hidden])'));
  };

  const activate = (menu, id, focus) => {
    const tab = menu.querySelector(`[data-uoy-tab="${id}"]`);
    if (!tab) return;
    menu.querySelectorAll('[data-uoy-tab]').forEach((t) => {
      const on = t === tab;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
    });
    menu.querySelectorAll('[data-uoy-panel]').forEach((panel) => {
      const on = panel.dataset.uoyPanel === id;
      panel.classList.toggle('is-active', on);
      panel.hidden = !on;
    });
    const panels = menu.querySelector('.uoy-mbm__panels');
    if (panels) panels.scrollTop = 0;
    if (drawerOpen()) showVisible(menu);
    if (focus) tab.focus();
    try { sessionStorage.setItem(STORE_KEY, id); } catch (_) { /* private mode */ }
  };

  document.addEventListener('click', (e) => {
    const tab = e.target.closest && e.target.closest('[data-uoy-tab]');
    if (!tab) return;
    e.preventDefault();
    activate(tab.closest('[data-uoy-mbm]'), tab.dataset.uoyTab);
  });

  document.addEventListener('keydown', (e) => {
    const tab = e.target.closest && e.target.closest('[data-uoy-tab]');
    if (!tab || !['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(e.key)) return;
    const tabs = [...tab.closest('[role="tablist"]').querySelectorAll('[data-uoy-tab]')];
    let i = tabs.indexOf(tab);
    if (e.key === 'ArrowDown') i = (i + 1) % tabs.length;
    else if (e.key === 'ArrowUp') i = (i - 1 + tabs.length) % tabs.length;
    else i = e.key === 'Home' ? 0 : tabs.length - 1;
    e.preventDefault();
    activate(tab.closest('[data-uoy-mbm]'), tabs[i].dataset.uoyTab, true);
  });

  // drawer opened: reopen the last category, load what is on screen
  const onOpen = () => {
    const menu = root();
    if (!menu) return;
    let saved = null;
    try { saved = sessionStorage.getItem(STORE_KEY); } catch (_) { /* private mode */ }
    if (saved && menu.querySelector(`[data-uoy-tab="${saved}"]`) && !menu.querySelector(`[data-uoy-tab="${saved}"].is-active`)) {
      activate(menu, saved);
    } else {
      showVisible(menu);
    }
  };
  const watchDrawer = () => {
    const drawer = document.querySelector(DRAWER);
    if (!drawer) return;
    new MutationObserver(() => { if (drawerOpen()) onOpen(); }).observe(drawer, { attributes: true, attributeFilter: ['aria-hidden'] });
    // the menu may arrive while the drawer is already open
    new MutationObserver(() => { if (drawerOpen()) onOpen(); }).observe(drawer, { childList: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchDrawer, { once: true });
  else watchDrawer();

  // theme editor
  const SECTION = 'uoy-mb-menu';
  const openDrawer = () => {
    if (drawerOpen()) return;
    const button = [...document.querySelectorAll('[data-menu-drawer]')].find((b) => b.offsetParent !== null);
    if (button) button.click();
  };
  document.addEventListener('shopify:section:select', (e) => {
    if (e.detail && e.detail.sectionId === SECTION) openDrawer();
  });
  document.addEventListener('shopify:block:select', (e) => {
    if (!e.detail || e.detail.sectionId !== SECTION) return;
    openDrawer();
    const menu = root();
    if (menu) activate(menu, e.detail.blockId);
  });
})();
